<template lang="pug">
  span(v-if="submissionDueDateText") {{ submissionDueDateText }}
  span.text-neutral-500(v-else) N/A
</template>

<script>
import { DateTime } from 'luxon'

export default {
  props: {
    panelData: {
      type: Object,
      default: null
    }
  },
  computed: {
    submissionDueDateText() {
      if (!this.panelData) return null

      const submissionType = this.panelData.submission_due_type
      const submissionValue = this.panelData.submission_due_value
      const submissionUnit = this.panelData.submission_due_unit
      const submissionTime = this.panelData.submission_due_time

      // Handle fixed deadline
      if (submissionType === 'fixed') {
        if (!submissionValue || !submissionUnit) return null
        return `${this.$t('panel.submit')} ${submissionValue} ${submissionUnit} ${this.$t('panel.after_invoice_finalised')}`
      }

      // Handle relative deadline
      if (submissionType === 'relative') {
        if (!submissionUnit || !submissionTime) return null

        const formattedTime = this.formatTime(submissionTime)

        // Daily frequency
        if (submissionUnit === 'daily') {
          const dailyOptions = {
            0: this.$t('panel.same_day'),
            1: this.$t('panel.next_day'),
            2: this.$t('panel.days_after_2'),
            3: this.$t('panel.days_after_3')
          }
          const dayText = dailyOptions[submissionValue] || ''
          return `${this.$t('panel.submit_daily')} ${formattedTime} ${dayText}`.trim()
        }

        // Weekly frequency
        if (submissionUnit === 'weekly') {
          const weeklyDays = {
            1: 'next Sunday',
            2: 'next Monday',
            3: 'next Tuesday',
            4: 'next Wednesday',
            5: 'next Thursday',
            6: 'next Friday',
            7: 'next Saturday'
          }
          const dayText = weeklyDays[submissionValue] || ''
          return `${this.$t('panel.submit_weekly')} ${formattedTime} ${dayText}`.trim()
        }

        // Monthly frequency
        if (submissionUnit === 'monthly') {
          const monthlyDays = {
            1: '1st day of next month',
            2: '2nd day of next month',
            3: '3rd day of next month',
            4: '4th day of next month',
            31: 'last day of the month'
          }
          const dayText = monthlyDays[submissionValue] || ''
          return `${this.$t('panel.submit_monthly')} ${formattedTime} ${dayText}`.trim()
        }
      }

      return null
    }
  },
  methods: {
    formatTime(timeString) {
      if (!timeString) return ''

      try {
        // Parse time in HH:mm or HH:mm:ss format
        let time = DateTime.fromFormat(timeString, 'HH:mm:ss')

        if (!time.isValid) return timeString

        // Convert to 12-hour format without seconds, with lowercase am/pm
        return time.toFormat('h:mma').toLowerCase()
      } catch (error) {
        console.error('Error formatting time:', error)
        return timeString
      }
    }
  }
}
</script>

